(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-or-products"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelector('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }

              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
              setupAnalytics(this);
            })
            .catch(e => {
              console.error(e);
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: '0px 0px 200px 0px'
        }).observe(this);
      }
    }

    customElements.define('product-recommendations', ProductRecommendations);
  }

  if (document.querySelector('section.featured-collection')) {
    document.querySelectorAll('section.featured-collection').forEach(section => {
      setupAnalytics(section);
    });
  }

  function setupAnalytics(recommendations) {
    recommendations.querySelectorAll('li').forEach(recommendation => {
      if (recommendation.querySelector('h2')) {
        const itemName = recommendation.querySelector('h2').innerText || "";
        recommendation.querySelectorAll('a').forEach(itemLink => {
          itemLink.addEventListener('click', function (event) {
            const dataLayer = (window._mtm = window._mtm || []);
            dataLayer.push({
              'event': 'productRecommendationItemClick',
              'category': 'ecommerce',
              'action': 'product recommendation click',
              'name': itemName.toLowerCase().replace(',', '')
            });
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
